import React from 'react'
import propTypes from 'prop-types'
import styled from 'styled-components'
import * as spacing from 'styles/spacing'
import { fontWeights } from 'styles/typography'
import Icon from 'components/Icon'
import { numberWithComma } from 'utils/formatters'
import { rewardsSilver, rewardsGold, rewardsPlatinum } from 'styles/colors'

const Container = styled.div`
  width: 100%;
  color: #2a2a2a;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${spacing.medium};
  padding: 30px 40px;
  margin: ${spacing.medium} 0;

  border: 1px solid #dedede;
  border-radius: 25px;
  ${(props) => {
    switch (props.tier) {
      case 'silver':
        return `border: 1px solid #dedede;
        background:${rewardsSilver};`
      case 'gold':
        return `border :1px solid #e9dcc2;
        background:${rewardsGold};`
      case 'platinum':
        return `border :1px solid #131313;
        background:${rewardsPlatinum};
        color:#fff;`
      default:
        return `border: 1px solid #dedede;
        background:${rewardsSilver};`
    }
  }};
  p {
    margin-bottom: 0;
  }
`

const Points = styled.div`
  display: flex;
  justify-content: left;
  width: 100%;
  .points {
    text-transform: uppercase;
  }
  .point-text {
    margin-left: 2px;
  }
  font-size: 34px;
  font-weight: ${fontWeights.bold};
  text-align: left;
`
const PointValue = styled.div`
  display: flex;
  justify-content: left;
  width: 100%;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;

  ${(props) => {
    switch (props.tier) {
      case 'platinum':
        return `color:#fff;`
      default:
        return `color: #878787;`
    }
  }};

  line-height: normal;
  text-align: left;
`
const PointsWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  width: 100%;
`

const Perk = styled.p`
  width: 100%;
  font-weight: ${fontWeights.light};
  text-align: left;
  font-size: 15px;
`

const Tier = styled.span`
  text-transform: capitalize;
`

const VRIcon = styled(Icon)`
  width: 90px;
`
const VRText = styled.h3`
  width: 90px;
  font-size: 25px;
  font-weight: 200;

  text-transform: lowercase;
  letter-spacing: 1.2px;
  margin-top: -10px;
`
const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  -webkit-font-smoothing: subpixel-antialiased;
`
const TitleText = styled.span`
  display: block;
  font-weight: 350;
  text-transform: capitalize;
  color: inherit;
  font-size: 24px;
`
const VuseRewardsTier = ({ userRewards }) => {
  const creditsToCurrencyRatio = userRewards?.creditsToCurrencyRatio || 0.0025
  return (
    <Container tier={userRewards?.tier?.toLowerCase()}>
      <TitleContainer>
        <LogoContainer>
          <VRIcon icon="vuse-rewards/myvuserewards" />
          <VRText>rewards</VRText>
        </LogoContainer>
        <TitleText>{userRewards?.tier}</TitleText>
      </TitleContainer>
      <PointsWrap>
        <Points>
          <p className="points">{numberWithComma(userRewards?.availablePoints)}</p> <p className="point-text">pts</p>
        </Points>
        <PointValue tier={userRewards?.tier?.toLowerCase()}>
          <p>{`Worth $${numberWithComma(userRewards?.availablePoints * creditsToCurrencyRatio)}`}</p>
        </PointValue>
      </PointsWrap>
      {userRewards?.tier?.toLowerCase() !== 'platinum' && (
        <Perk>
          You're
          <strong>
            <Tier>{` ${userRewards?.pointsToNextTier}  `}</Tier>pts
          </strong>
          {` away from unlocking`}
          <strong>
            <Tier>{` ${userRewards?.nextTier} `}</Tier>
          </strong>
          benefits
        </Perk>
      )}
      {userRewards?.tier?.toLowerCase() == 'platinum' && (
        <Perk>
          You've unlocked the{' '}
          <strong>
            <Tier>{` ${userRewards?.tier} `}</Tier>
          </strong>
          our highest tier with premium benefits.
        </Perk>
      )}
    </Container>
  )
}

VuseRewardsTier.propTypes = {
  userRewards: propTypes.object,
}

export default VuseRewardsTier
